import React, { useMemo, FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from './UploadingFileError.types';
import { pipe, pathOr } from 'ramda';
import { getErrorInfo } from '../../../../utils/uploadingFile';
import { useExtractErrorArgs } from './useExtractErrorArgs';

export const UploadingFileError: FC<IOuter> = ({ uploadError, translationsPrefix }) => {
  const extractErrorArgs = useExtractErrorArgs();

  const translationProps = useMemo(
    () =>
      pipe(getErrorInfo, (errorInfo) => ({
        id: `${translationsPrefix}${errorInfo.key}`,
        values: extractErrorArgs(errorInfo),
        defaultMessage: pathOr<string, string>('', ['data', 'error_description'], uploadError),
      }))(uploadError),
    [uploadError, extractErrorArgs, translationsPrefix],
  );

  return <FormattedMessage {...translationProps} />;
};
